import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { fuseAnimations } from '@fleet/fuse';
import {
  DriverModel,
  JobModel,
  TicketModel,
  TravellerModel,
  VehicleModel,
} from '@fleet/model';
import { TicketCreateEditComponent } from '../ticket-create-edit/ticket-create-edit.component';
import { TicketLinkComponent } from '../ticket-link/ticket-link.component';

@Component({
  selector: 'fleet-ticket-action-button',
  templateUrl: './ticket-action-button.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: fuseAnimations,
})
export class TicketActionButtonComponent implements OnInit {
  @Input() driver: DriverModel;
  @Input() vehicle: VehicleModel;
  @Input() traveller: TravellerModel;
  @Input() job: JobModel;
  @Input() ticket: TicketModel;

  @Output() actionSuccessful = new EventEmitter();

  constructor(private matDialog: MatDialog) {}

  ngOnInit(): void {}

  createTicket() {
    const dialog = this.matDialog.open(TicketCreateEditComponent);

    if (this.driver) {
      dialog.componentInstance.driver = this.driver;
    }
    if (this.traveller) {
      dialog.componentInstance.traveller = this.traveller;
    }
    if (this.vehicle) {
      dialog.componentInstance.vehicle = this.vehicle;
    }
    if (this.job) {
      dialog.componentInstance.job = this.job;
    }

    dialog.componentInstance.cancelled.subscribe(() => {
      dialog.close();
    });
    dialog.componentInstance.successful.subscribe((ticket: TicketModel) => {
      dialog.close();
      this.actionSuccessful.emit();
    });
  }

  linkTicket() {
    const dialog = this.matDialog.open(TicketLinkComponent);

    if (this.driver) {
      dialog.componentInstance.driver = this.driver;
    }
    if (this.traveller) {
      dialog.componentInstance.traveller = this.traveller;
    }
    if (this.job) {
      dialog.componentInstance.job = this.job;
    }
    if (this.ticket) {
      dialog.componentInstance.ticket = this.ticket;
    }
    if (this.vehicle) {
      dialog.componentInstance.vehicle = this.vehicle;
    }

    dialog.componentInstance.cancelled.subscribe(() => {
      dialog.close();
    });

    dialog.componentInstance.successful.subscribe((ticket: TicketModel) => {
      dialog.close();
      this.actionSuccessful.emit();
    });
  }
}
